import { Formik } from 'formik';
import { object, string } from 'yup';
import React, { useCallback } from 'react';

import { patchMemoir } from '../api';
import { prepareAttrs } from '../../utils/api';
import { useEntity, useEntityActionCreators } from '../../entities/hooks';
import { useHistory, useMatch } from '../../app/hooks';
import FullPageForm from '../../app/full-page-form';
import NewCollectionName from '../../collections/new/name';

const MemoirName = () => {
  const { push } = useHistory();
  const { params } = useMatch();
  const { entity } = useEntity(params);
  const { receive } = useEntityActionCreators();

  const onBackClick = useCallback(() => {
    if (entity['subject-relation'] === 'me') {
      return push(`/memoirs/new/${entity.id}/subject-type`);
    }
    return push(`/memoirs/new/${entity.id}/subject-name`);
  }, [entity, push]);
  const initialValues = {
    name: `${entity['first-name']}'s story`,
  };
  const validationSchema = object().shape({
    name: string(),
  });
  const isInitialValid = validationSchema.isValidSync(initialValues);

  return (
    <FullPageForm onBackClick={onBackClick} title="Create a Memoir">
      <Formik
        {...{ initialValues, validationSchema, isInitialValid }}
        onSubmit={async values => {
          const body = prepareAttrs({ ...values, 'lock-version': entity['lock-version'] });

          // PATCH child journal
          const payload = await patchMemoir({ id: entity.id, ...body });
          receive({ payload });
          push(`/memoirs/new/${entity.id}/date-of-birth`);
        }}
        render={formikProps => (
          <NewCollectionName
            attr="name"
            label="Name of the memoir"
            skipPath={`/memoirs/new/${entity.id}/date-of-birth`}
            {...formikProps}
          />
        )}
      />
    </FullPageForm>
  );
};

export default MemoirName;
